
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/affordable-storage-rates",
      function () {
        return require("private-next-pages/affordable-storage-rates/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/affordable-storage-rates"])
      });
    }
  